export default function LpAiRecommendation() {
  return <div />;
}
